module.exports = __webpack_public_path__ + "static/media/fenglou.c7d5238d.png";